import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HealthCheckService } from '@interacta-shared/util-common';

export const outOfServiceGuard: CanActivateFn = () => {
    const healthCheckService = inject(HealthCheckService);
    const router: Router = inject(Router);
    return healthCheckService.getOutOfService() || router.createUrlTree(['/']);
};
